import type { MapMarker } from "../map.type";
import type { InfoWindowProps } from "@vis.gl/react-google-maps";

export const getInfoWindowPixelOffset = (
  marker: MapMarker
): InfoWindowProps["pixelOffset"] => {
  const anchorOffset = marker.anchorOffset ?? 0;

  const widthOffset = 0;
  const heightOffset = -anchorOffset - 4;

  return [widthOffset, heightOffset];
};
